// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
var _ = require('lodash');
import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import Button from 'grommet/components/Button';
import CheckBox from 'grommet/components/CheckBox';
import FormField from 'grommet/components/FormField';

import EditControl from './Controls';
import DeepSensorControl from './DeepSensorControl';
import constants from '../../Constants';

var twigObject = { settings: {} };
class EditTwig extends Component {

  constructor(props) {
    super(props);
    this.state = {
      show: this.props.show
    }
    this.saveTwig = this.saveTwig.bind(this);
    this.controlValueChange = this.controlValueChange.bind(this);
    this.renderTwigControls = this.renderTwigControls.bind(this);
  }
  componentWillMount() {
    twigObject = { settings: {} }
  }


  componentDidMount() {

  }

  componentWillReceiveProps(nextProps) {
    let element = ReactDOM.findDOMNode(this.refs.editTwigContent);
    element.scrollTop = 0;
    this.setState({
      show: nextProps.show
    })
  }

  componentWillUnmount() {
    twigObject = { settings: {} }
  }


  saveTwig() {
    this.props.saveTwig(twigObject);
  }

  controlValueChange(controlInfo, event) {
    let value = '';
    if (controlInfo.controlType == constants.TWIG_EDIT_CONTROLS.NUMBER_ARRAY || controlInfo.controlType == constants.TWIG_EDIT_CONTROLS.STRING_ARRAY) {
      value = event;
    } else {
      value = event.target.value;
    }
    if (controlInfo.key == 'name' || controlInfo.key == 'locationName') {
      twigObject[controlInfo.key] = value;
    } else {
      twigObject.settings[controlInfo.key] = {
        value: value
      }
    }
    this.setState({ twigObject });

  }

  renderTwigControls() {
    if (this.props.show && this.props.selectedTwig.settings) {
      let controlsArr = [];
      let staticControl = ['name', 'locationName']
      for (let i = 0; i < staticControl.length; i++) {
        let label = staticControl[i] == 'name' ? 'Stem Name' : 'Stem Location'
        controlsArr.push(
          <EditControl controlType={constants.TWIG_EDIT_CONTROLS.NUMBER} label={label} value={this.props.selectedTwig[staticControl[i]]} key={staticControl[i]} controlKey={staticControl[i]} controlValueChange={this.controlValueChange} />
        )
      }

      let objectToArr = [];
      for (let key in this.props.selectedTwig.settings) {
        let control = this.props.selectedTwig.settings[key];
        control['key'] = key;
        objectToArr.push(control)
      }
      let sortedArr = _.sortBy(objectToArr, [function (o) { return o.key; }]);

      for (let i = 0; i < sortedArr.length; i++) {
        // for (let key in this.props.selectedTwig.settings) {
        let control = sortedArr[i];
        if (control.key === 'sensorName' || control.key === 'plantType' || control.key === 'siteName' || control.key === 'soilType') {
          if (control.inputType == constants.TWIG_EDIT_CONTROLS.NUMBER_ARRAY || control.inputType == constants.TWIG_EDIT_CONTROLS.STRING_ARRAY) {
            controlsArr.push(
              <DeepSensorControl label={control.label} controlType={control.inputType} value={control.value} key={control.key} controlKey={control.key} controlValueChange={this.controlValueChange} />
            )
          } else {
            let parseClass = '';
            let hasUser = control.hasUser ? true : false;
            if (control.inputType == constants.TWIG_EDIT_CONTROLS.SELECT) {
              parseClass = control.parseClass;
            }

            controlsArr.push(
              <EditControl parseClass={parseClass} hasUser={hasUser} controlType={control.inputType} label={control.label} selectedTwig={this.props.selectedTwig} key={control.key} controlKey={control.key} controlValueChange={this.controlValueChange} 
                value={twigObject.settings[control.key] && twigObject.settings[control.key].value ? twigObject.settings[control.key].value : control.value}
              />
            )
          }
        }

      }
      return controlsArr;
    } else {
      return null;
    }

  }


  render() {
    let toRender = null;
    let twigId = (this.props.selectedTwig && this.props.selectedTwig.twigId) ? this.props.selectedTwig.twigId : '';
    return (
      <div className={'map-overlay ' + (this.props.show ? 'show' : 'hide')} >
        <div className="edit-twig-content" ref="editTwigContent">
          <h3>{'Stem - ' + twigId}</h3>
          {this.renderTwigControls()}

          <div className="overlay-btn-container">
            <Button
              label='Update'
              onClick={this.saveTwig}
              primary={true}
              className="mr-5" />
            <Button
              label='Cancel'
              onClick={this.props.closeEditPop}
              primary={true} />
          </div>
        </div>
      </div>
    );
  }

}

export default EditTwig;




// WEBPACK FOOTER //
// ./src/js/components/site/EditTwig.js